
import React from 'react';
import { TableCell, TableRow } from "@/components/ui/table";
import { AlertCircle } from "lucide-react";

const EmptyUsersList: React.FC = () => {
  return (
    <TableRow>
      <TableCell colSpan={7} className="text-center py-8">
        <div className="flex flex-col items-center justify-center space-y-2">
          <AlertCircle className="h-8 w-8 text-amber-500" />
          <p className="text-muted-foreground">Aucun utilisateur trouvé</p>
          <p className="text-sm text-muted-foreground max-w-md">
            Si vous vous attendiez à voir des utilisateurs ici, vérifiez que :<br />
            1. Les comptes ont été créés correctement<br />
            2. Les profiles utilisateurs existent dans la table 'profiles'<br />
            3. Les champs obligatoires (id, email, role) sont présents<br />
            4. L'état de l'authentification est bien synchronisé
          </p>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default EmptyUsersList;
